import TBAutomationActionTypes from './tb-automation.types';

export const setTbMessage = (message) => ({
  type: TBAutomationActionTypes.SET_TB_MESSAGE,
  payload: message,
});

export const setStatus = (status) => ({
  type: TBAutomationActionTypes.SET_STATUS,
  payload: status,
});

export const setColor = (color) => ({
  type: TBAutomationActionTypes.SET_COLOR,
  payload: color,
});

export const resetAutomationState = () => ({
  type: TBAutomationActionTypes.RESET_STATE,
  payload: null,
});

export const getLastRunStart = () => ({
  type: TBAutomationActionTypes.GET_LAST_RUN_START,
});

export const getLastRunSuccess = (date) => ({
  type: TBAutomationActionTypes.GET_LAST_RUN_SUCCESS,
  payload: date,
});

export const getLastRunFailure = (error) => ({
  type: TBAutomationActionTypes.GET_LAST_RUN_FAILURE,
  payload: error,
});
